import { useEffect, useState } from "react";

const VERSES = [
  { text: "What time I am afraid, I will trust in thee.", ref: "Psalm 56:3" },
  { text: "I can do all things through Christ which strengtheneth me.", ref: "Philippians 4:13" },
  { text: "The Lord is my shepherd; I shall not want.", ref: "Psalm 23:1" },
  { text: "Be strong and of a good courage; be not afraid, neither be thou dismayed: for the Lord thy God is with thee whithersoever thou goest.", ref: "Joshua 1:9" },
  { text: "Trust in the Lord with all thine heart; and lean not unto thine own understanding.", ref: "Proverbs 3:5" },
  { text: "For I know the thoughts that I think toward you, saith the Lord, thoughts of peace, and not of evil, to give you an expected end.", ref: "Jeremiah 29:11" },
  { text: "And we know that all things work together for good to them that love God.", ref: "Romans 8:28" },
  { text: "Cast thy burden upon the Lord, and he shall sustain thee.", ref: "Psalm 55:22" },
  { text: "Give, and it shall be given unto you; good measure, pressed down, and shaken together, and running over.", ref: "Luke 6:38" },
  { text: "He hath shewed thee, O man, what is good; and what doth the Lord require of thee, but to do justly, and to love mercy, and to walk humbly with thy God?", ref: "Micah 6:8" },
  { text: "Bear ye one another's burdens, and so fulfil the law of Christ.", ref: "Galatians 6:2" },
  { text: "Let your light so shine before men, that they may see your good works, and glorify your Father which is in heaven.", ref: "Matthew 5:16" },
  { text: "Whatsoever ye do, do it heartily, as to the Lord, and not unto men.", ref: "Colossians 3:23" },
  { text: "The Lord is my light and my salvation; whom shall I fear?", ref: "Psalm 27:1" },
  { text: "Be still, and know that I am God.", ref: "Psalm 46:10" },
];

export function RotatingVerse({ className = "" }: { className?: string }) {
  const [index, setIndex] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setMounted(true);
    setIndex(Math.floor(Math.random() * VERSES.length));
  }, []);

  useEffect(() => {
    if (!mounted) return;
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % VERSES.length);
        setVisible(true);
      }, 500);
    }, 7000);
    return () => clearInterval(interval);
  }, [mounted]);

  const verse = VERSES[index];

  if (!mounted) {
    return (
      <p className={`italic ${className}`} aria-live="polite">
        "{verse.text}" — {verse.ref}
      </p>
    );
  }

  return (
    <p
      className={`italic transition-opacity duration-500 ${visible ? "opacity-100" : "opacity-0"} ${className}`}
      aria-live="polite"
    >
      "{verse.text}" — {verse.ref}
    </p>
  );
}
